import { render, staticRenderFns } from "./MessagesOverview.vue?vue&type=template&id=b08be33c&"
import script from "./MessagesOverview.vue?vue&type=script&lang=ts&"
export * from "./MessagesOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataIterator } from 'vuetify/lib'
installComponents(component, {VContainer,VDataIterator})
